import { BaseUnitConfig } from 'unitData/BaseUnitConfig';
import type { UnitInfoInterface } from 'store/units/types';
import { UnitTypes } from 'unitData/types';

import { crusherJawCJConfig } from 'unitData/Crushers/CrusherJawCJ/CrusherJawCJData';
import { crusherConeCHConfig } from 'unitData/Crushers/CrusherConeCH/CrusherConeCHData';
import { crusherConeCSConfig } from 'unitData/Crushers/ConeCrusherCS/ConeCrusherCSData';
import { gyratoryCrusherCGConfig } from 'unitData/Crushers/GyratoryCrusherCG/GyratoryCrusherData';
import { crusherVSIConfig } from 'unitData/Crushers/CrusherVSI/CrusherVSIData';
import { impactCrusherCIConfig } from 'unitData/Crushers/ImpactCrusherCI/ImpactCrusherCIData';
import { hybridCrusherCRConfig } from 'unitData/Crushers/HybridCrusherCR/HybridCrusherCRData';
import { genericCrusherConfig } from 'unitData/Generic/GenericCrusher/GenericCrusherData';
import { mobileJawConfig } from 'unitData/Mobile/Jaw/premiumJawData';
import { circularMotionScreenConfig } from 'unitData/CircularMotionScreen/CircularMotionScreenData';
import { linearMotionScreenConfig } from 'unitData/LinearMotionScreen/LinearMotionScreenData';
import { multislopeScreenConfig } from 'unitData/MultislopeScreen/MultislopeScreenData';
import { bananaScreenConfig } from 'unitData/BananaScreen/BananaScreenData';
import { schenckScreenConfig } from 'unitData/SchenckScreen/SchenckScreenData';
import { kwataniScreenConfig } from 'unitData/KwataniScreen/KwataniScreenData';
import { freeFallScreenSFConfig } from 'unitData/FreeFallScreenSF/freeFallScreenSFData';
import { freeFallScreenSSConfig } from 'unitData/FreeFallScreenSS/freeFallScreenSSData';
import { grizzlyScreenConfig } from 'unitData/GrizzlyScreenSG/GrizzlyScreenSGData';
import { genericScreenConfig } from 'unitData/Generic/GenericScreen/GenericScreenData';
import { panFeederSPConfig } from 'unitData/Feeders/Pan/PanFeederSPData';
import { plateFeederSHConfig } from 'unitData/Feeders/Plate/PlateFeederSPData';
import { grizzlyFeederSWConfig } from 'unitData/Feeders/Grizzly/GrizzlyFeederSWData';
import { grizzlyFeederSVConfig } from 'unitData/Feeders/Grizzly/GrizzlyFeederSVData';
import { grizzlyFeederSVEConfig } from 'unitData/Feeders/Grizzly/GrizzlyFeederSVEData';
import { feederScreenConfig } from 'unitData/Feeders/FeederScreen/FeederScreenData';
import { storageConfig } from 'unitData/Storage/StorageData';
import { addConfig } from 'unitData/Add/AddData';
import { splitConfig } from 'unitData/Split/SplitData';
import { mobileConeConfig } from 'unitData/Mobile/Cone/MobileUnitConeCrusherData';
import { mobileHSIConfig } from 'unitData/Mobile/HSI/hsiData';
import { mobileScreenConfig } from 'unitData/Mobile/Screen/mobileScreenData';
import { mobileVSIConfig } from 'unitData/Mobile/VSI/vsiData';
import { mobileJawAndConeConfig } from 'unitData/Mobile/JawAndCone/jawAndConeData';
import { breakerConfig } from 'unitData/Breaker/BreakerData';
import { feedConfig } from 'unitData/Feed/FeedData';

class GenericUnitConfig extends BaseUnitConfig {
  constructor(
    private defaultData: UnitInfoInterface,
    private portCount: number,
  ) {
    super();
  }
  getDefaultData(): UnitInfoInterface {
    return this.defaultData;
  }
  getNumberOfPorts(): number {
    return this.portCount;
  }
}

export const UNIT_CONFIGS = {
  [UnitTypes.JAW_CRUSHER_CJ]: crusherJawCJConfig,
  [UnitTypes.CONE_CRUSHER_CH]: crusherConeCHConfig,
  [UnitTypes.CONE_CRUSHER_CS]: crusherConeCSConfig,
  [UnitTypes.IMPACT_CRUSHER_CI]: impactCrusherCIConfig,
  [UnitTypes.GYRATORY_CRUSHER_CG]: gyratoryCrusherCGConfig,
  [UnitTypes.IMPACT_CRUSHER_CV]: crusherVSIConfig,
  [UnitTypes.HYBRID_CRUSHER_CR]: hybridCrusherCRConfig,
  [UnitTypes.GENERIC_CRUSHER]: genericCrusherConfig,
  [UnitTypes.BREAKER]: breakerConfig,

  [UnitTypes.CONVENTIONAL_SCREEN]: circularMotionScreenConfig,
  [UnitTypes.LINEAR_MOTION_SCREEN]: linearMotionScreenConfig,
  [UnitTypes.MULTISLOPE_SCREEN]: multislopeScreenConfig,
  [UnitTypes.BANANA_SCREEN]: bananaScreenConfig,
  [UnitTypes.SCHENCK_SCREEN]: schenckScreenConfig,
  [UnitTypes.KWATANI_SCREEN]: kwataniScreenConfig,
  [UnitTypes.FREEFALL_SCREEN_SF]: freeFallScreenSFConfig,
  [UnitTypes.FREEFALL_SCREEN_SS]: freeFallScreenSSConfig,
  [UnitTypes.GRIZZLY_SCREEN]: grizzlyScreenConfig,
  [UnitTypes.GENERIC_SCREEN]: genericScreenConfig,

  [UnitTypes.PAN_FEEDER_SP]: panFeederSPConfig,
  [UnitTypes.PLATE_FEEDER_SH]: plateFeederSHConfig,
  [UnitTypes.GRIZZLY_FEEDER_SW]: grizzlyFeederSWConfig,
  [UnitTypes.GRIZZLY_FEEDER_SV]: grizzlyFeederSVConfig,
  [UnitTypes.GRIZZLY_FEEDER_SV_E]: grizzlyFeederSVEConfig,
  [UnitTypes.FEEDER_AND_SCREEN]: feederScreenConfig,

  [UnitTypes.STORAGE_FEEDER]: storageConfig,
  [UnitTypes.STORAGE_FEEDER_2_OUTPUTS]: storageConfig,
  [UnitTypes.STORAGE]: storageConfig,
  [UnitTypes.ADD]: addConfig,
  [UnitTypes.SPLIT]: splitConfig,
  [UnitTypes.FEED]: feedConfig,

  [UnitTypes.MOBILE_TRACKED_JAW]: mobileJawConfig,
  [UnitTypes.MOBILE_WHEELED_JAW]: mobileJawConfig,
  [UnitTypes.MOBILE_TRACKED_CONE]: mobileConeConfig,
  [UnitTypes.MOBILE_WHEELED_CONE]: mobileConeConfig,
  [UnitTypes.MOBILE_TRACKED_HSI]: mobileHSIConfig,
  [UnitTypes.MOBILE_WHEELED_HSI]: mobileHSIConfig,
  [UnitTypes.MOBILE_TRACKED_SCREEN]: mobileScreenConfig,
  [UnitTypes.MOBILE_WHEELED_SCREEN]: mobileScreenConfig,
  [UnitTypes.MOBILE_VSI]: mobileVSIConfig,
  [UnitTypes.MOBILE_JAW_AND_CONE]: mobileJawAndConeConfig,

  [UnitTypes.FREE_TEXT_BOX]: new GenericUnitConfig(
    {
      modelName: '',
      parallelUnits: 1,
      moisture: 0,
      newMoisture: false,
      message: 'Click to edit',
      width: 100,
      height: 50,
      displayBorder: true,
      color: '#FFFFFF',
      fontSize: 10,
      textColor: '#000000',
      textAlignment: 'center' as const,
      textWeight: 'regular' as const,
      display: {
        displayNotes: {
          noteOne: false,
          noteTwo: false,
          noteThree: false,
          noteFour: false,
          noteFive: false,
        },
        displayUnitName: false,
        displayModelName: false,
      },
    },
    0,
  ),
  [UnitTypes.GRIZZLY_FEEDER_GENERAL]: new GenericUnitConfig({}, 0),
  [UnitTypes.MOBILE_JAW_COMMON]: new GenericUnitConfig({}, 0),
  [UnitTypes.MOBILE_CONE_COMMON]: new GenericUnitConfig({}, 0),
  [UnitTypes.MOBILE_SCREEN_COMMON]: new GenericUnitConfig({}, 0),
  [UnitTypes.MOBILE_HSI_COMMON]: new GenericUnitConfig({}, 0),
  [UnitTypes.PRINT_WINDOW]: new GenericUnitConfig({}, 0),
  [UnitTypes.HIGHLIGHT_TEXT_BOX]: new GenericUnitConfig({}, 0),
} satisfies Record<UnitTypes, BaseUnitConfig>;

/**
 * Get the configuration class for a unit type.
 * @returns BaseUnitConfig instance for the unit type
 */
export function getUnitConfig(unitType: UnitTypes): BaseUnitConfig {
  const config = UNIT_CONFIGS[unitType];
  if (!config) throw new Error(`No config registered for: ${unitType}`);
  return config;
}

export function getAllRegisteredUnitTypes(): UnitTypes[] {
  return Object.keys(UNIT_CONFIGS) as UnitTypes[];
}

export const getScreenOutputPortCount = (nbrOfDecks: number) => nbrOfDecks + 1;

export function getPortsForUnit(
  unitType: UnitTypes,
  variantId?: number,
): { inputPorts: number; outputPorts: number } {
  // Explicit port mapping restored from original getPorts() logic
  // This matches the GoJS templates which are the source of truth
  switch (unitType) {
    case UnitTypes.FEED:
      return { inputPorts: 0, outputPorts: 1 };
    case UnitTypes.STORAGE:
      return { inputPorts: 1, outputPorts: 0 };
    case UnitTypes.STORAGE_FEEDER:
      return { inputPorts: 1, outputPorts: 1 };
    case UnitTypes.STORAGE_FEEDER_2_OUTPUTS:
      return { inputPorts: 1, outputPorts: 2 };
    case UnitTypes.FREE_TEXT_BOX:
      return { inputPorts: 0, outputPorts: 0 };
    case UnitTypes.ADD:
      return { inputPorts: variantId ?? 2, outputPorts: 1 };
    case UnitTypes.SPLIT:
      return { inputPorts: 1, outputPorts: variantId ?? 2 };

    // All crushers: 1 input (top), 1 output (bottom)
    case UnitTypes.JAW_CRUSHER_CJ:
    case UnitTypes.CONE_CRUSHER_CH:
    case UnitTypes.CONE_CRUSHER_CS:
    case UnitTypes.GYRATORY_CRUSHER_CG:
    case UnitTypes.IMPACT_CRUSHER_CI:
    case UnitTypes.IMPACT_CRUSHER_CV:
    case UnitTypes.HYBRID_CRUSHER_CR:
    case UnitTypes.GENERIC_CRUSHER:
      return { inputPorts: 1, outputPorts: 1 };

    case UnitTypes.BREAKER:
      return { inputPorts: 1, outputPorts: 1 };

    // Feeders: 1 input, 1 output
    case UnitTypes.PAN_FEEDER_SP:
    case UnitTypes.PLATE_FEEDER_SH:
      return { inputPorts: 1, outputPorts: 1 };

    // Grizzly feeders: 1 input, 3 outputs (overflow + up to 2 deck undersizes)
    case UnitTypes.GRIZZLY_FEEDER_SW:
    case UnitTypes.GRIZZLY_FEEDER_SV:
    case UnitTypes.GRIZZLY_FEEDER_SV_E:
      return { inputPorts: 1, outputPorts: 3 };

    // Grizzly screen: 1 input, 3 outputs (overflow + up to 2 deck undersizes)
    case UnitTypes.GRIZZLY_SCREEN:
      return { inputPorts: 1, outputPorts: 3 };

    // Generic screen: 1 input, 2 outputs
    case UnitTypes.GENERIC_SCREEN:
      return { inputPorts: 1, outputPorts: 2 };

    // Screens with 3 outputs (1 input + multiple deck outputs)
    case UnitTypes.CONVENTIONAL_SCREEN:
    case UnitTypes.LINEAR_MOTION_SCREEN:
    case UnitTypes.MULTISLOPE_SCREEN:
    case UnitTypes.BANANA_SCREEN:
    case UnitTypes.SCHENCK_SCREEN:
    case UnitTypes.KWATANI_SCREEN:
    case UnitTypes.FREEFALL_SCREEN_SS:
      return { inputPorts: 1, outputPorts: 3 };

    // Screens with 4 outputs
    case UnitTypes.FREEFALL_SCREEN_SF:
      return { inputPorts: 1, outputPorts: 4 };

    case UnitTypes.FEEDER_AND_SCREEN:
      return { inputPorts: 1, outputPorts: 3 };

    // Mobile units - most have 1 input + variable outputs
    case UnitTypes.MOBILE_TRACKED_JAW:
    case UnitTypes.MOBILE_WHEELED_JAW:
    case UnitTypes.MOBILE_TRACKED_CONE:
    case UnitTypes.MOBILE_TRACKED_HSI:
      return { inputPorts: 1, outputPorts: 1 };
    case UnitTypes.MOBILE_WHEELED_HSI:
      return { inputPorts: 1, outputPorts: 2 };
    case UnitTypes.MOBILE_VSI:
      return { inputPorts: 1, outputPorts: 3 };
    case UnitTypes.MOBILE_WHEELED_CONE:
    case UnitTypes.MOBILE_TRACKED_SCREEN:
      return { inputPorts: 1, outputPorts: 4 };
    case UnitTypes.MOBILE_JAW_AND_CONE:
      return { inputPorts: 1, outputPorts: 5 };
    case UnitTypes.MOBILE_WHEELED_SCREEN:
      return { inputPorts: 1, outputPorts: 6 };

    default:
      return { inputPorts: 0, outputPorts: 0 };
  }
}

export function getPortLimits(unitType: UnitTypes): {
  maxInputPorts: number;
  maxOutputPorts: number;
  minInputPorts: number;
  minOutputPorts: number;
} {
  const { inputPorts, outputPorts } = getPortsForUnit(unitType);

  switch (unitType) {
    case UnitTypes.ADD:
      return {
        maxInputPorts: 4,
        maxOutputPorts: 1,
        minInputPorts: 2,
        minOutputPorts: 1,
      };
    case UnitTypes.SPLIT:
      return {
        maxInputPorts: 1,
        maxOutputPorts: 3,
        minInputPorts: 1,
        minOutputPorts: 2,
      };
    case UnitTypes.CONVENTIONAL_SCREEN:
    case UnitTypes.LINEAR_MOTION_SCREEN:
    case UnitTypes.FREEFALL_SCREEN_SF:
    case UnitTypes.FREEFALL_SCREEN_SS:
    case UnitTypes.GENERIC_SCREEN:
      return {
        maxInputPorts: inputPorts,
        maxOutputPorts: 5,
        minInputPorts: inputPorts,
        minOutputPorts: 2,
      };
    case UnitTypes.GRIZZLY_SCREEN:
    case UnitTypes.GRIZZLY_FEEDER_SW:
    case UnitTypes.GRIZZLY_FEEDER_SV:
    case UnitTypes.GRIZZLY_FEEDER_SV_E:
      return {
        maxInputPorts: inputPorts,
        maxOutputPorts: 3,
        minInputPorts: inputPorts,
        minOutputPorts: outputPorts,
      };
    case UnitTypes.MOBILE_TRACKED_JAW:
    case UnitTypes.MOBILE_WHEELED_JAW:
      return {
        maxInputPorts: inputPorts,
        maxOutputPorts: 3,
        minInputPorts: inputPorts,
        minOutputPorts: outputPorts,
      };
    case UnitTypes.MOBILE_TRACKED_CONE:
      return {
        maxInputPorts: inputPorts,
        maxOutputPorts: 3,
        minInputPorts: inputPorts,
        minOutputPorts: outputPorts,
      };
    case UnitTypes.MOBILE_WHEELED_CONE:
      return {
        maxInputPorts: inputPorts,
        maxOutputPorts: 5,
        minInputPorts: inputPorts,
        minOutputPorts: outputPorts,
      };
    case UnitTypes.MOBILE_TRACKED_HSI:
      return {
        maxInputPorts: inputPorts,
        maxOutputPorts: 4,
        minInputPorts: inputPorts,
        minOutputPorts: outputPorts,
      };
    case UnitTypes.MOBILE_WHEELED_HSI:
      return {
        maxInputPorts: inputPorts,
        maxOutputPorts: 2,
        minInputPorts: inputPorts,
        minOutputPorts: outputPorts,
      };
    case UnitTypes.MOBILE_VSI:
      return {
        maxInputPorts: inputPorts,
        maxOutputPorts: 5,
        minInputPorts: inputPorts,
        minOutputPorts: outputPorts,
      };
    case UnitTypes.MOBILE_TRACKED_SCREEN:
      return {
        maxInputPorts: inputPorts,
        maxOutputPorts: 5,
        minInputPorts: inputPorts,
        minOutputPorts: outputPorts,
      };
    default:
      return {
        maxInputPorts: inputPorts,
        maxOutputPorts: outputPorts,
        minInputPorts: inputPorts,
        minOutputPorts: outputPorts,
      };
  }
}
